module.exports = __webpack_public_path__ + "static/img/mirrorImg1.8f48070.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mirrorImg1.png
// module id = d24J
// module chunks = 2